import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconSearchProps extends SVGProps<any> {}
export class SVGIconSaveAsh extends Component<SVGIconSearchProps> {
  render() {
    const {
      width = 30,
      height = 30,
      color = '##00000040',
      ...rest
    } = this.props;
    return (
      <SVG
        className="svg-icon-angle"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 36 32`}
        // fill={color}
        {...rest}
      >
        <g>
          <path
            d="M28.17 5.15253L24.8475 1.83002C24.2686 1.24795 23.5799 0.786499 22.8214 0.472377C22.063 0.158256 21.2497 -0.0022932 20.4288 2.47453e-05H6.25C4.59301 0.00200957 3.00445 0.661127 1.83277 1.8328C0.661102 3.00447 0.00198482 4.59303 0 6.25002L0 23.75C0.00198482 25.407 0.661102 26.9956 1.83277 28.1672C3.00445 29.3389 4.59301 29.998 6.25 30H23.75C25.407 29.998 26.9956 29.3389 28.1672 28.1672C29.3389 26.9956 29.998 25.407 30 23.75V9.57127C30.0023 8.75032 29.8418 7.93706 29.5276 7.17858C29.2135 6.4201 28.7521 5.73146 28.17 5.15253ZM21.25 2.60002V3.75002C21.25 4.74459 20.8549 5.69841 20.1517 6.40168C19.4484 7.10494 18.4946 7.50002 17.5 7.50002H12.5C11.5054 7.50002 10.5516 7.10494 9.84835 6.40168C9.14509 5.69841 8.75 4.74459 8.75 3.75002V2.50002H20.4288C20.7054 2.50248 20.9809 2.53602 21.25 2.60002ZM27.5 23.75C27.5 24.7446 27.1049 25.6984 26.4017 26.4017C25.6984 27.1049 24.7446 27.5 23.75 27.5H6.25C5.25544 27.5 4.30161 27.1049 3.59835 26.4017C2.89509 25.6984 2.5 24.7446 2.5 23.75V6.25002C2.5 5.25546 2.89509 4.30164 3.59835 3.59837C4.30161 2.89511 5.25544 2.50002 6.25 2.50002V3.75002C6.25198 5.40702 6.9111 6.99558 8.08278 8.16725C9.25445 9.33892 10.843 9.99804 12.5 10H17.5C19.0719 9.99515 20.584 9.3971 21.7339 8.32548C22.8839 7.25386 23.5869 5.78764 23.7025 4.22002L26.4025 6.92002C27.103 7.62487 27.4974 8.57752 27.5 9.57127V23.75Z"
            fill="white"
          />

          <path
            d="M15 12.5C14.0111 12.5 13.0444 12.7932 12.2222 13.3427C11.3999 13.8921 10.759 14.673 10.3806 15.5866C10.0022 16.5002 9.90315 17.5055 10.0961 18.4755C10.289 19.4454 10.7652 20.3363 11.4645 21.0355C12.1637 21.7348 13.0546 22.211 14.0246 22.4039C14.9945 22.5969 15.9998 22.4978 16.9134 22.1194C17.8271 21.741 18.6079 21.1001 19.1574 20.2779C19.7068 19.4556 20 18.4889 20 17.5C20 16.1739 19.4732 14.9021 18.5355 13.9645C17.5979 13.0268 16.3261 12.5 15 12.5ZM15 20C14.5055 20 14.0222 19.8534 13.6111 19.5787C13.2 19.304 12.8795 18.9135 12.6903 18.4567C12.5011 17.9999 12.4516 17.4972 12.548 17.0123C12.6445 16.5273 12.8826 16.0819 13.2322 15.7322C13.5819 15.3826 14.0273 15.1445 14.5123 15.048C14.9972 14.9516 15.4999 15.0011 15.9567 15.1903C16.4135 15.3795 16.804 15.7 17.0787 16.1111C17.3534 16.5222 17.5 17.0055 17.5 17.5C17.5 18.163 17.2366 18.7989 16.7678 19.2678C16.2989 19.7366 15.663 20 15 20Z"
            fill="white"
          />
        </g>
      </SVG>
    );
  }
}
